import { FunctionComponent } from 'react';
import styles from './FeedingMoments.module.scss';
import { Option } from '@spike/model';
import { useMasterData } from 'hooks';
import Checkbox from 'components/UI/V3/Forms/Checkbox';

interface FeedingMomentsProps {
    onMomentsChange: (moments: Array<number>) => void;
    selectedMoments: Array<number>;
    disabled?: Array<number>;
    editing?: boolean;
}

const FeedingMoments: FunctionComponent<FeedingMomentsProps> = props => {
    const feedingMomentTypes = useMasterData().feedingMomentTypes;

    const handleMomentChange = (moment: number, checked: boolean) => {
        if (props.disabled?.includes(moment) && !props.selectedMoments.includes(moment)) {
            return;
        }

        let newMoments: Array<number>;

        if (props.editing) {
            if (checked) {
                newMoments = [moment];
            } else {
                newMoments = [];
            }
        } else {
            if (checked) {
                newMoments = [...props.selectedMoments, moment];
            } else {
                newMoments = props.selectedMoments.filter(m => m !== moment);
            }
        }

        props.onMomentsChange(newMoments);
    };

    return (
        <div className={styles.feedingMomentsContainer}>
            {feedingMomentTypes.map((moment: Option<number>) => (
                <div
                    key={moment.id}
                    className={styles.momentItem}
                >
                    <Checkbox
                        label={moment.name}
                        checked={props.selectedMoments.includes(moment.id)}
                        onChange={(checked: boolean) => handleMomentChange(moment.id, checked)}
                        className={
                            props.disabled?.includes(moment.id) && !props.selectedMoments.includes(moment.id)
                                ? styles.disabled
                                : undefined
                        }
                    />
                </div>
            ))}
        </div>
    );
};

export default FeedingMoments;
